import { connect } from "react-redux";
import { readAppData } from "shared/redux-store/dataReaders";
import OrderUnitsOverview from "./OrderUnitsOverview";
import { removeOrderUnit } from "./orderUnitsOverviewActions";

const mapStateToProps = state => {
  return {
    orderUnits: readAppData(state, "orderUnits"),
    hasProducts: readAppData(state, "products").length > 0,
    submitErrorMessages: state.app.submitErrorMessages,
    submitSuccessMessage: state.app.submitSuccessMessage,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    removeOrderUnitFn: orderUnitId => {
      dispatch(
        removeOrderUnit({
          pathParams: [orderUnitId],
          requestData: {},
        }),
      );
    },
  };
};

const OrderUnitsOverviewContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrderUnitsOverview);

export default OrderUnitsOverviewContainer;
